import { render, staticRenderFns } from "./CategoryViewLogs.vue?vue&type=template&id=6e11c670"
import script from "./CategoryViewLogs.vue?vue&type=script&lang=js"
export * from "./CategoryViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports